import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { ReviewDownloadDialogComponent } from '../../../../post-trade/components/review-download-dialog/review-download-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DecimalPipe } from '@angular/common';
import { saveAs } from '@progress/kendo-file-saver';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-download-grid-report',
  templateUrl: './download-grid-report.component.html',
  styleUrls: ['./download-grid-report.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
})
export class DownloadGridReportComponent {
  @Input() fileLoading = false;
  @Input() gridData = {
    data: [],
    headers: [],
    subHead: [],
    total: 0,
  };
  @Input() getData;
  @Input() generateQueryData;
  @Input() gridConfig;
  @Input() hidden = [];
  @Input() selectedRecords = [];
  @Input() bulkSelect = false;
  @Input() reportFilters: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  };
  @Output() toggleLoading = new EventEmitter();

  private decimalPipe = inject(DecimalPipe);
  dialog = inject(MatDialog);

  downloadGridReport(audit = false) {
    this.toggleLoading.emit(true);
    if (this.gridConfig.downloadGridButtonProps?.action) {
      this.getData().subscribe({
        next: res => {
          this.toggleLoading.emit(false);
          const date = new Date();

          let fileData;
          const filename = `${this.gridConfig.title}-${date.toLocaleString(
            'en-US',
            {
              dateStyle: 'short',
            }
          )}.${this.getFileExt(this.gridConfig.downloadGridButtonProps?.action)}`;
          const reader = new FileReader();
          reader.readAsDataURL(res);

          reader.onloadend = () => {
            fileData = reader.result;
            saveAs(fileData, filename);
          };
        },
        error: () => {
          this.toggleLoading.emit(false);
        },
      });
    } else {
      this.toggleLoading.emit(false);
      const visibleColumns: string[] = [];

      this.gridData.headers.map(header => {
        if (!this.hidden.includes(header.DataField)) {
          visibleColumns.push(header.DataField);
        }
      });

      this.dialog.open(ReviewDownloadDialogComponent, {
        panelClass: 'trade-review-download',
        minHeight: '30vh',
        width: '50vw',
        data: {
          columns: visibleColumns,
          rows: this.gridData.total > 100000 ? 100000 : this.gridData.total,
          query: this.generateQueryData(this.reportFilters),
          gridType: this.gridConfig.gridType,
          audit: audit,
          selectedRecords: this.selectedRecords,
        },
        autoFocus: false,
      });
    }
  }

  getFileExt(fileType: string) {
    switch (fileType.split('/')[1]) {
      case 'xlsx':
        return 'xlsx';
      case 'text':
        return 'txt';
      default:
        return 'csv';
    }
  }

  formatRecordLimit(value: number) {
    return `Limit ${this.decimalPipe.transform(value, '1.0-0')}`;
  }
}
